"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareTypeEnum = void 0;
var ShareTypeEnum;
(function (ShareTypeEnum) {
    ShareTypeEnum["Disabled"] = "Disabled";
    ShareTypeEnum["Members"] = "Members";
    ShareTypeEnum["Public"] = "Public";
})(ShareTypeEnum = exports.ShareTypeEnum || (exports.ShareTypeEnum = {}));
//# sourceMappingURL=share-type-enum.js.map